export default "__VITE_ASSET__A$vks3m4__"